import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
export const ELETRONIC_PRESCRIPTION_FIELD_REASON_VALIDATOR = 'eletronic-prescription-field-reason-validator';
async function eletronicPrescriptionReasonValidator(value) {
    if (!value) {
        return [
            {
                message: MessageService.translate('message.eletronic-prescription.field-reason-requerid'),
                name: ELETRONIC_PRESCRIPTION_FIELD_REASON_VALIDATOR,
                valid: false,
            },
        ];
    }
    return [
        {
            message: '',
            name: ELETRONIC_PRESCRIPTION_FIELD_REASON_VALIDATOR,
            valid: true,
        },
    ];
}
export default eletronicPrescriptionReasonValidator;
//# sourceMappingURL=eletronic-prescription-field-reason-validator.js.map